import { Serializable } from '@core/models';

export class OutOfMenuDayService extends Serializable {
  constructor(title, products, forecastGroup) {
    super();
    this.title = title;
    if (forecastGroup.length === 0) this.forecastGroup = '';
    else this.forecastGroup = 'Demanda'.concat(' ', forecastGroup);
    this.products = products;
  }

  serialize() {
    return {};
  }

  formatForHtml() {
    return [this.title, ...this.products, this.forecastGroup];
  }

  static toInstance(props = {}) {
    return new OutOfMenuDayService(props.title, props.products, props.forecast_group);
  }
}
